import { RouterModule, Routes } from '@angular/router';

export const appRoutes: Routes = [
    {
        path: '',
        loadChildren: 'app/pages/home/home.module#HomeModule'
    },
    {
        path: 'about',
        loadChildren: 'app/pages/about/about.module#AboutModule'
    }
];


// WEBPACK FOOTER //
// /var/www/html/project/snsina/src/app/app.route.ts